import { UserDataService } from 'src/app/DataServices/user-data.service';
import { Component, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CustomPaggerService } from 'projects/Autofacets-Core/src/app/common-services/custom-pagger.service';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { NgbdSortableHeader, SortEvent } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { TechnicalManual } from '../../../business-entities/technical-manual-model';
import { TechnicalManualBusinessService } from './../../../business-services/technical-manual.service'
import * as fromEnums from 'projects/Autofacets-Core/src/app/utils/enums';
import { UserRoleMenu } from '../../../business-entities/user-role-menu.model';
import { ViewTechnicalManualComponent } from './view-technical-manual/view-technical-manual/view-technical-manual.component';
import { AddTechnicalManualComponent } from './add-technical-manual/add-technical-manual/add-technical-manual.component';
import { AdminCommonService } from '../../../services/admin-common.service';

@Component({
  selector: 'app-technical-manual',
  templateUrl: './technical-manual.component.html',
  styleUrls: ['./technical-manual.component.css']
})
export class TechnicalManualComponent implements OnInit, OnDestroy {
  total$: Observable<number>;
  technicalManualList: TechnicalManual[];
  popupCloseResult = false;
  paginationSub:Subscription;
  userRoleRightsDetails: UserRoleMenu;
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  constructor(
    private adminCommonService :AdminCommonService,
    private technicalManualService: TechnicalManualBusinessService,
    public pService: CustomPaggerService,
    private translate: TranslateService,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private userService: UserDataService,
    config: NgbModalConfig,
  ) {
    this.pService.pageSize = 10;
    this.pService.searchby = ['brand', 'manualUrl'];
    this.pService.searchTerm = '';

    config.backdrop = 'static';
    config.keyboard = false;
  }

  onSort({ column, direction }: SortEvent) {
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    this.pService.sortColumn = column;
    this.pService.sortDirection = direction;
  }

  ngOnInit(): void {
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === fromEnums.ModuleNames.TechnicalManual);
    this.pService.dataSource = [];
    this.getTechnicalManualList()
  }
  ngOnDestroy(): void {
    if(this.paginationSub) {
      this.paginationSub.unsubscribe();
    }
    this.pService.dealers$ = new BehaviorSubject<any[]>([]);
    this.pService.total$ = new BehaviorSubject<number>(0);
  }
  async getTechnicalManualList() {
    this.spinner.show();
    await this.technicalManualService.getTechnicalManualList().then((response) => {
      this.pService.dataSource = response;
      this.paginationSub = this.pService.dealers$.subscribe(result => {
        this.technicalManualList = this.technicalManualMapping(result);
      });
      this.total$ = this.pService.total$;
    })
    this.spinner.hide();
  }


  private technicalManualMapping(manualList: any) {
    let supperArray = [];
    if (manualList && manualList.length > 0) {

      for (let index = 0; index < manualList.length; index++) {
        const element = manualList[index];

        let single = Object();
        single.rowNumber = this.adminCommonService.currentPageNumber(index);
        single.id = element.id;
        single.brand = element.brand;
        single.brandCode = element.brandCode;
        single.brandId = element.brandId;
        single.createdBy = element.createdBy;
        single.createdDate = element.createdDate;
        single.isActive = element.isActive;
        single.manualUrl = element.manualUrl;
        single.updatedBy = element.updatedBy;
        single.updatedDate = element.updatedDate;
        supperArray.push(single);
      }
    }
    return supperArray;
  }
  deleteTechnicalManual(id: number) {
    let modelHeadermsg = this.translate.instant("lblDelete");
    let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"),this.translate.instant("lblTechnicalManual"),true);
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {
      // This is intentional
     }, (reason) => {
      this.popupCloseResult = this.adminCommonService.getDismissReason(reason);
      if (this.popupCloseResult) {
        this.technicalManualService.deleteTechnicalManual(id).then((response) => {
          if (response.responseCode == Constant.SuccessResponseCode) {
            let deletedmsg = this.translate.instant("lblTechnicalManualDeleted");
            this.toastr.success(deletedmsg)
            this.getTechnicalManualList();
          }
        });
      }
    });
  }
  viewTechnicalManual(id: number) {
    this.technicalManualService.technicalManualId = id
    const modalref = this.modalService.open(ViewTechnicalManualComponent, { size: 'md', windowClass: 'EditPopup' });
      modalref.result.then((response) => {
        if (response.success) {
          this.ngOnInit();
        }
      });
  }
  onAdd() {
    const modalref = this.modalService.open(AddTechnicalManualComponent, { size: 'md', windowClass: 'EditPopup' });
      modalref.result.then((response) => {
        if (response.success) {
          this.ngOnInit();
        }
      });
  }

}
